const products = [
  { id: 'potash', value: 60, filename: 'Pot', label: 'PotAsh 60%' },
  {
    id: 'muriate',
    value: 62,
    filename: 'MPot',
    label: 'Muriate of PotAsh 62%',
  },
  { id: 'other', value: '', filename: 'Other_K', label: 'Other' },
];

export const potassium = {
  groups: [25, 50, 75, 100],
  products,
  getProduct: (id, percentage) => {
    const product = products.find((p) => p.id === id);
    return product ? product.label : `Other ${percentage}%`;
  },
};
